<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {copyClipboard, getDateFormat} from 'src/components/cabinet/#common/helpers'
    import {delay} from '../../../global/delay'
    import {userProfile} from 'src/services/auth'
    import copyIcon from 'src/components/#assets/copy.svg'
    import stepsIcon from 'src/components/cabinet/referrals/steps.svg'
    import step1Icon from 'src/components/cabinet/referrals/step-1.svg'
    import step2Icon from 'src/components/cabinet/referrals/step-2.svg'
    import step3Icon from 'src/components/cabinet/referrals/step-3.svg'
    import earningsIcon from 'src/components/cabinet/referrals/earnings.svg'
    import schema from 'src/components/cabinet/referrals/schema.svg'
    import howWorksIcon from 'src/components/cabinet/referrals/how-works.svg'
    import overviewIcon from 'src/components/cabinet/referrals/overviewIcon.svg'
    import xIcon from 'src/components/cabinet/referrals/xIcon.svg'
    import telegramIcon from 'src/components/cabinet/referrals/telegramIcon.svg'
    import linkIcon from 'src/components/cabinet/referrals/linkIcon.svg'
    import downloadIcon from 'src/components/cabinet/referrals/downloadIcon.svg'
    import rightIcon from 'src/components/cabinet/referrals/right.svg'
    import {
        getAllMyReferralRewards,
        getReferralInfoList, getReferralReward,
        getSubReferralsCount
    } from 'src/components/cabinet/#services/myReferrals'
    import {myTransactions} from "src/components/cabinet/#services/myTransactions"
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte'
    import {roundNumber} from 'src/components/#common/helpers/helpers'
    import {Link} from 'svelte-routing'

    let howItWorksModalOpen = false
    let inviteFriendsModalOpen = false
    let options = { year: 'numeric', month: 'long', day: 'numeric' }
    let selectedImage = '/images/referral/all-games.png'

    $: myTransactions.send({ data: { reasons: ['21','subReferral'], page: 1, perPage: 6 }})
    getAllMyReferralRewards.send()
    getReferralInfoList.send({ data: { userId: $userProfile.userId, page: 1, perPage: 3 } })
    getSubReferralsCount.send()
    getReferralReward.send()

    async function copy(event, value) {
        let button = event.currentTarget
        button.setAttribute('data-tooltip', 'Copied')
        copyClipboard(value)
        await delay(2500)
        button.removeAttribute('data-tooltip')
    }

    function selectImage(link) {
        selectedImage = link
    }
</script>

<svelte:head>
    <title>Referrals</title>
</svelte:head>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <div class="page-title">Referrals</div>
            <div class="row">
                <div class="col-xl-6 col-xxl-5">
                    <div class="links-card">
                        <div class="subtitle">Referral Links & Code</div>
                        <div class="percents">
                            <div class="percent">
                                From referrals spends
                                <div class="percent-count">5%</div>
                            </div>
                            <div class="percent">
                                From sub referrals spends
                                <div class="percent-count">3%</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="label">Your Referral Code</div>
                            <div class="input-wrapper">
                                <input type="text" readonly class="input w-100"  value="{$userProfile.userId}">
                                <button class="copy-btn" on:click={(e) => copy(e, $userProfile.userId)}>
                                    <img src="{copyIcon}" alt="copy">
                                </button>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="label">Your Referral Link</div>
                            <div class="input-wrapper">
                                <input type="text" readonly class="input w-100" value="https://realis.network/r/{$userProfile.userId}">
                                <button class="copy-btn" on:click={(e) => copy(e, 'https://realis.network/r/'+$userProfile.userId)}>
                                    <img src="{copyIcon}" alt="copy">
                                </button>
                            </div>
                        </div>
                        <button class="active-btn w-100" on:click={() => {inviteFriendsModalOpen = true}}>
                            <span>Invite friends</span>
                        </button>
                        <button class="how-works-modal-btn" on:click={() => {howItWorksModalOpen = true}}>
                            <img src="{howWorksIcon}" alt="">How it works
                        </button>
                    </div>
                </div>
                <div class="col-xl-6 col-xxl-7">
                    {#if $getReferralInfoList.loading}
                        Loading...
                    {:else if $getReferralInfoList.hasValue && $getReferralInfoList.value?.totalCount === 0}
                        <div class="schema">
                            <img src="{schema}" alt="schema">
                        </div>
                    {:else}
                        <div class="transaction-wrapper">
                            <div class="subtitle">Last Transactions</div>
                            {#if $myTransactions.loading}
                                <div class="transactions">Loading...</div>
                            {:else if $myTransactions.error || !$myTransactions.hasValue }
                                <div class="transactions">Something went wrong. Try refreshing the page.</div>
                            {:else if $myTransactions.hasValue}
                                <div class="transactions">
                                    {#each $myTransactions.value.data as {debit, currency, reason, createdAt}}
                                        <div class="transaction">
                                            <div class="green">+{roundNumber(+debit)} {currency}</div>
                                            <div>{reason}</div>
                                            <div>{getDateFormat(createdAt)}</div>
                                        </div>
                                    {/each}
                                </div>
                            {/if}
                        </div>
                    {/if}
                </div>
            </div>
            <div class="dark-wrapper">
                {#if $getReferralInfoList.hasValue && $getReferralInfoList.value?.totalCount === 0}
                    <div class="wrapper-title">
                        <div class="icon-wrapper">
                            <img src="{stepsIcon}" alt="">
                        </div>
                        How it works
                    </div>
                    <div class="row steps">
                        <div class="col-lg-4">
                            <div class="step-card">
                                <div class="step-icon">
                                    <img src="{step1Icon}" alt="">
                                </div>
                                <div class="step-title">Step 1</div>
                                <div class="step-description">
                                    Сopy your referral link from Realis Wallet
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="step-card">
                                <div class="step-icon">
                                    <img src="{step2Icon}" alt="">
                                </div>
                                <div class="step-title">Step 2</div>
                                <div class="step-description">
                                    Share your referral link with your friends and invite them to play Realis games
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-4">
                            <div class="step-card">
                                <div class="step-icon">
                                    <img src="{step3Icon}" alt="">
                                </div>
                                <div class="step-title">Step 3</div>
                                <div class="step-description">
                                    Get reward for every LIS spent of your referral and sub-referral
                                </div>
                            </div>
                        </div>
                    </div>
                {/if}
                <div class="wrapper-title">
                    <div class="icon-wrapper">
                        <img src="{earningsIcon}" alt="">
                    </div>
                    My Earnings
                </div>
                <div class="earnings">
                    <div class="row">
                        <div class="col-12 col-lg-4 earnings-card">
                            <div class="earnings-title">Total</div>
                            <div class="earnings-value">
                                {#if !$getAllMyReferralRewards.hasValue}
                                    ...
                                {:else if $getAllMyReferralRewards.hasValue}
                                    {$getAllMyReferralRewards.value.total}
                                {/if}
                                LIS
                            </div>
                            {#if $getAllMyReferralRewards.hasValue && $getAllMyReferralRewards.value.totalNewest > 0}
                                <div class="earnings-growth">+{$getAllMyReferralRewards.value.totalNewest} LIS</div>
                            {/if}
                        </div>
                        <div class="col-6 col-lg-4 earnings-card">
                            <div class="earnings-title">From Referrals</div>
                            <div class="earnings-value">
                                {#if !$getAllMyReferralRewards.hasValue}
                                    ...
                                {:else if $getAllMyReferralRewards.hasValue}
                                    {$getAllMyReferralRewards.value.referrals}
                                {/if}
                                LIS
                            </div>
                            {#if $getAllMyReferralRewards.hasValue && $getAllMyReferralRewards.value.rewardRefNewest > 0}
                                <div class="earnings-growth">+{$getAllMyReferralRewards.value.rewardRefNewest} LIS</div>
                            {/if}
                        </div>
                        <div class="col-6 col-lg-4 earnings-card">
                            <div class="earnings-title">From Sub Referrals</div>
                            <div class="earnings-value">
                                {#if !$getAllMyReferralRewards.hasValue}
                                    ...
                                {:else if $getAllMyReferralRewards.hasValue}
                                    {$getAllMyReferralRewards.value.subReferrals}
                                {/if}
                                LIS
                            </div>
                            {#if $getAllMyReferralRewards.hasValue && $getAllMyReferralRewards.value.rewardSubRefNewest > 0}
                                <div class="earnings-growth">+{$getAllMyReferralRewards.value.rewardSubRefNewest} LIS</div>
                            {/if}
                        </div>
                    </div>
                </div>
                <div class="earnings-description">
                    * Rewards for Referrals and SubReferrals in-game spending will be credited 7 days after they are made.
                    {#if $getReferralReward.hasValue && $getReferralReward.value?.reward > 0}
                        Your potential reward: <span class="orange">{$getReferralReward.value.reward} LIS</span>.
                    {/if}
                </div>
                <div class="wrapper-title">
                    <div class="icon-wrapper">
                        <img src="{overviewIcon}" alt="">
                    </div>
                    Overview
                </div>
                <div class="overview">
                    <div class="row">
                        <div class="col-lg-6">
                            <div class="overview-card">
                                <div class="row">
                                    <div class="col-6 col-xxl-7">
                                        <div class="overview-title">Referrals</div>
                                        <div class="overview-value">
                                            {#if $getReferralInfoList.hasValue}
                                                {$getReferralInfoList.value.totalCount}
                                            {:else}...{/if}
                                        </div>
                                        {#if $getReferralInfoList.hasValue && $getReferralInfoList.value.newest > 0}
                                            <div class="overview-growth">+{$getReferralInfoList.value.newest}</div>
                                        {/if}
                                    </div>
                                    <div class="col-6 col-xxl-5">
                                        <div class="overview-title">Sub Referrals</div>
                                        <div class="overview-value">
                                            {#if $getSubReferralsCount.hasValue}
                                                {$getSubReferralsCount.value.total}
                                            {:else}...{/if}
                                        </div>
                                        {#if $getSubReferralsCount.hasValue && $getSubReferralsCount.value.newest > 0}
                                            <div class="overview-growth">+{$getSubReferralsCount.value.newest}</div>
                                        {/if}
                                    </div>
                                </div>
                                <button class="active-btn" on:click={() => {inviteFriendsModalOpen = true}}>
                                    <span>Invite friends</span>
                                </button>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="referrals-list-wrapper">
                                {#if $getReferralInfoList.loading}
                                    <div class="referrals-list">Loading...</div>
                                {:else if $getReferralInfoList.hasValue && $getReferralInfoList.value.totalCount}
                                    {#if $getReferralInfoList.value.totalCount > 0}
                                        <div class="referrals-list">
                                            <div class="my-referrals-table">
                                                <div class="referrals-table-header">
                                                    <div>Referral</div>
                                                    <div>Date</div>
                                                </div>
                                                <div class="referrals-table-body">
                                                    {#each $getReferralInfoList.value.data as {nickname, registryDate}}
                                                        <div class="referrals-table-row">
                                                            <div class="notranslate">{nickname.replace(/#([^#]+)$/, '')}</div>
                                                            <div>{getDateFormat(registryDate)}</div>
                                                        </div>
                                                    {/each}
                                                </div>
                                            </div>
                                            <Link to="referrals/all" class="all-referrals-btn">
                                                View all <img src="{rightIcon}" alt="">
                                            </Link>
                                        </div>
                                    {:else}
                                        <div class="text-center">No referrals</div>
                                    {/if}
                                {/if}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal bind:visible={inviteFriendsModalOpen}>
            <svelte:fragment slot="content">
                <div class="modal-custom__text text-center">
                    <a href="{selectedImage}" download>
                        <img src="{selectedImage}" class="referral-image" alt="">
                    </a>
                    <div class="images-preview">
                        <div>
                            <label on:click={() => selectImage('/images/referral/all-games.png')}>
                                <img src="/images/referral/all-games.png" alt="">
                                <input type="radio" name="image" class="form-check-input" checked>
                            </label>
                        </div>
                        <div>
                            <label on:click={() => selectImage('/images/referral/cats.png')}>
                                <img src="/images/referral/cats.png" alt="">
                                <input type="radio" name="image" class="form-check-input">
                            </label>
                        </div>
                        <div>
                            <label on:click={() => selectImage('/images/referral/dragons.png')}>
                                <img src="/images/referral/dragons.png" alt="">
                                <input type="radio" name="image" class="form-check-input">
                            </label>
                        </div>
                        <div>
                            <label on:click={() => selectImage('/images/referral/fox.png')}>
                                <img src="/images/referral/fox.png" alt="">
                                <input type="radio" name="image" class="form-check-input">
                            </label>
                        </div>
                        <div>
                            <label on:click={() => selectImage('/images/referral/doge.png')}>
                                <img src="/images/referral/doge.png" alt="">
                                <input type="radio" name="image" class="form-check-input">
                            </label>
                        </div>
                        <div>
                            <label on:click={() => selectImage('/images/referral/elon.png')}>
                                <img src="/images/referral/elon.png" alt="">
                                <input type="radio" name="image" class="form-check-input">
                            </label>
                        </div>
                        <div>
                            <label on:click={() => selectImage('/images/referral/pepe.png')}>
                                <img src="/images/referral/pepe.png" alt="">
                                <input type="radio" name="image" class="form-check-input">
                            </label>
                        </div>
                    </div>
                    <div class="icons">
                        <a href="https://twitter.com/intent/tweet?url={encodeURIComponent('https://realis.network/r/'+$userProfile.userId)}" class="icon" target="_blank">
                            <img src="{xIcon}" alt="">
                        </a>
                        <a href="https://telegram.me/share/url?url={encodeURIComponent('https://realis.network/r/'+$userProfile.userId)}" class="icon" target="_blank">
                            <img src="{telegramIcon}" alt="">
                        </a>
                        <div class="icon copy-btn" on:click={(e) => copy(e, 'https://realis.network/r/'+$userProfile.userId)}>
                            <img src="{linkIcon}" alt="">
                        </div>
                        <a href="{selectedImage}" class="icon" download>
                            <img src="{downloadIcon}" alt="">
                        </a>
                    </div>
                </div>
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={howItWorksModalOpen} size="lg">
            <svelte:fragment slot="content">
                <div class="modal-custom__title text-center">How it works</div>
                <div class="modal-custom__text">
                    <img src="{schema}" class="modal-schema" alt="schema">
                    <div class="modal-earnings-text">
                        Rewards for Referrals and SubReferrals in-game spending will be credited 7 days after they are made.
                        {#if $getReferralReward.hasValue && $getReferralReward.value?.reward > 0}
                            Your potential reward: <span class="orange">{$getReferralReward.value.reward} LIS</span>.
                        {/if}
                    </div>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    .links-card {
        border-radius: 20px;
        border: 2px solid #353064;
        background: #26244D;
        padding: 50px;
        height: 100%;
    }

    .subtitle {
        color: white;
        font-size: 25px;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 30px;
    }

    .percents {
        border-radius: 10px;
        background: #494591;
        margin-bottom: 30px;
        padding: 20px;
        display: flex;
        justify-content: center;
    }

    .percent {
        width: 50%;
        font-size: 16px;
        line-height: 1;
    }

    .percent:first-child {
        padding-left: 20px;
        margin-right: 10px;
    }

    .percent-count {
        color: white;
        font-size: 30px;
        font-weight: 800;
        margin-top: 5px;
        line-height: 1;
    }

    .label {
        color: #9592CD;
        font-size: 16px;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 8px;
    }

    .input-wrapper {
        margin-bottom: 20px;
    }

    .form-group {
        max-width: initial !important;
    }

    .links-card .active-btn {
        margin-top: 30px;
    }

    .dark-wrapper {
        padding: 50px;
        border-radius: 50px;
        background: #181636;
        margin-top: 80px;
    }

    .wrapper-title {
        display: flex;
        align-items: center;
        color: white;
        font-size: 30px;
        font-weight: 600;
        line-height: normal;
        margin-bottom: 30px;
    }

    .icon-wrapper {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-content: center;
        background: white;
        box-shadow: 0 -1px 1px 0 rgba(1, 7, 10, 0.3) inset;
        filter: drop-shadow(0px 1px 2px rgba(1, 7, 10, 0.30));
        margin-right: 20px;
        border-radius: 50%;
    }

    .icon-wrapper img {
        width: 30px;
    }

    .steps {
        margin-bottom: 80px;
    }

    .step-card {
        background: #26244D;
        border: 2px solid #494591;
        padding: 30px;
        border-radius: 20px;
        height: 100%;
    }

    .step-icon {
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-content: center;
        border-radius: 50%;
        background: #7262FF;
        box-shadow: 0 2px 1px 0 rgba(255, 255, 255, 0.2) inset, 0 -2px 1px 0 rgba(1, 7, 10, 0.3) inset;
        margin-bottom: 46px;
    }

    .step-icon img {
        width: 50px;
    }

    .step-title {
        padding: 8px 15px;
        display: table;
        border-radius: 27px;
        background: #3c3a67;
        color: white;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        margin-bottom: 15px;
    }

    .step-description {
        color: white;
        font-size: 15px;
        font-weight: 500;
        line-height: normal;
    }

    .earnings {
        padding: 80px;
        border-radius: 20px;
        background: #26244D;
    }

    .earnings-title {
        color: #9592CD;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 20px;
    }

    .earnings-value {
        color: white;
        font-size: 40px;
        font-weight: 800;
        line-height: 100%;
    }

    .earnings-growth {
        color: #27AE60;
        font-size: 15px;
        font-weight: 600;
        line-height: normal;
        margin-top: 10px;
    }

    .earnings-description {
        color: #CAD5E0;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.5;
        margin: 20px 0 80px;
    }

    .schema {
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .schema img {
        height: 100%;
        max-width: 100%;
        padding: 20px;
    }

    .overview-title {
        color: #9592CD;
        font-size: 18px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 20px;
    }

    .overview-value {
        color: white;
        font-size: 40px;
        font-weight: 800;
        line-height: 100%;
    }

    .overview-growth {
        color: #27AE60;
        font-size: 15px;
        font-weight: 600;
        line-height: normal;
        margin-top: 10px;
    }

    .overview-card {
        padding: 80px;
        border-radius: 20px;
        background: #26244D;
        height: 100%;
    }

    .overview-card .active-btn {
        margin: 60px auto 0;
        display: table;
        padding-left: 110px;
        padding-right: 110px;
    }

    .how-works-modal-btn {
        border-radius: 63px;
        background: #2C2A54;
        border: 0;
        font-size: 14px;
        font-weight: 500;
        color: white;
        margin: 30px auto 0;
        display: table;
        padding: 8px 10px;
        line-height: 16px;
        transition: .2s;
    }

    .how-works-modal-btn img {
        width: 20px;
        height: 20px;
        margin: -4px 5px -2px 0;
    }

    .how-works-modal-btn:hover {
        background: #343168;
    }

    .modal-schema {
        margin-bottom: 30px;
        max-width: 100%;
        background: #1C1A3F;
        border-radius: 20px;
        padding: 16px 15px;
        width: 100%;
    }

    .modal-earnings-text {
        color: white;
        font-size: 17px;
        line-height: 1.4;
        margin-bottom: 20px;
    }

    .icons {
        display: flex;
        justify-content: center;
        margin-top: 30px;
    }

    .icon {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        border: 1px solid #9592CD;
        background: #26244D;
        box-shadow: 0 1px 2px 0 rgba(1, 7, 10, 0.4) inset, 0 -1px 2px 0 rgba(1, 7, 10, 0.4) inset;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 15px;
        transition: .2s;
        cursor: pointer;
    }

    .icon:hover {
        background: #363468;
    }

    .referral-image {
        margin: 40px auto 0;
        max-width: 390px;
    }

    .transaction-wrapper {
        border-radius: 20px;
        border: 2px solid #353064;
        background: #1a183a;
        padding: 50px;
        height: 100%;
    }

    .transactions {
        margin-top: 60px;
    }

    .transaction {
        display: flex;
        border-bottom: 2px solid #343168;
        padding-bottom: 30px;
        margin-bottom: 30px;
        font-size: 16px;
    }

    .transaction:last-child {
        border-bottom: 0;
        padding-bottom: 0;
        margin-bottom: 0;
    }

    .transaction > div {
        width: 30%;
    }

    .transaction > div:nth-child(2) {
        padding: 0 6px;
        width: 40%;
    }

    .green {
        color: #27AE60;
        font-weight: 500;
    }

    .orange {
        color: #e78e08;
        font-weight: 500;
    }

    :global(.all-referrals-btn) {
        border-radius: 33px;
        background: #2C2A54;
        color: white;
        font-size: 14px;
        padding: 8px 8px 8px 16px;
        font-weight: 500;
        line-height: 16px;
        text-decoration: none;
        display: table;
        margin: 0 auto;
        transition: .2s;
    }

    :global(.all-referrals-btn:hover) {
        background: #353362;
        color: white;
    }

    :global(.all-referrals-btn img) {
        width: 20px;
        vertical-align: top;
        margin: -2px 0;
    }

    .referrals-list-wrapper {
        border-radius: 20px;
        border: 2px solid #353064;
        background: #1a183a;
        padding: 30px;
        height: 100%;
    }

    .form-group {
        max-width: 550px;
        width: 100%;
    }

    .referrals-table-header {
        display: flex;
        width: 100%;
        margin: 0 0 30px;
    }

    .referrals-table-header > div {
        width: 50%;
        padding: 11px 20px;
        background: #494591;
        color: #c3c0ed;
        font-size: 17px;
        line-height: 20px;
        font-weight: 500;
    }

    .referrals-table-header > div:first-child {
        border-radius: 8px 0 0 8px;
    }

    .referrals-table-header > div:last-child {
        border-radius: 0 8px 8px 0;
    }

    .referrals-table-row {
        display: flex;
        margin-bottom: 20px;
        padding-bottom: 20px;
        border-bottom: 2px solid #343168;
    }

    .referrals-table-row > div {
        width: 50%;
        padding: 0 20px;
        font-size: 16px;
        line-height: 20px;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        display: block;
    }

    .input-wrapper .input {
        padding-right: 50px;
    }

    .images-preview {
        display: flex;
        justify-content: center;
        border-bottom: 2px solid #343168;
        padding-bottom: 30px;
        margin: 25px 0 30px;
    }

    .images-preview > div {
        margin: 0 10px;
    }

    .images-preview label {
        cursor: pointer;
    }

    .images-preview img {
        max-width: 100%;
        margin-bottom: 10px;
    }

    @media(max-width: 1600px) {
        .percent:first-child {
            padding-left: 0;
        }

        .earnings {
            padding: 60px;
        }

        .earnings-value {
            font-size: 36px;
        }

        .overview-card {
            padding: 60px;
        }
    }

    @media(max-width: 1600px) {
        .earnings-value {
            font-size: 30px;
        }

        .links-card,
        .transaction-wrapper,
        .dark-wrapper,
        .earnings,
        .overview-card {
            padding: 40px;
        }

        .dark-wrapper {
            margin-top: 60px;
            border-radius: 40px;
        }

        .steps {
            margin-bottom: 60px;
        }

        .schema img {
            padding: 0;
        }
    }

    @media(max-width: 1399px) {
        .step-icon {
            width: 70px;
            height: 70px;
        }

        .step-icon img {
            width: 40px;
        }

        .step-title {
            font-size: 18px;
        }

        .wrapper-title {
            font-size: 26px;
        }

        .overview-card .active-btn {
            width: 100%;
            padding-left: 15px;
            padding-right: 15px;
        }

        .overview-value {
            font-size: 30px;
        }

        .links-card,
        .transaction-wrapper,
        .dark-wrapper,
        .earnings,
        .overview-card {
            padding: 24px;
        }

        .percent-count {
            font-size: 26px;
        }

        .percent:first-child {
            max-width: 160px;
        }
    }

    @media(max-width: 1199px) {
        .percent:first-child {
            max-width: initial;
            margin-right: 0;
        }

        .schema {
            display: none;
        }

        .percent {
            text-align: center;
        }

        .transaction-wrapper {
            margin-top: 40px;
            height: initial;
        }

        .dark-wrapper {
            margin-top: 40px;
            border-radius: 20px;
        }

        .earnings-description {
            font-size: 14px;
            margin: 20px 0 50px;
        }

        .step-card {
            padding: 20px;
        }

        .transaction {
            padding-bottom: 25px;
            margin-bottom: 25px;
        }

        .step-icon {
            width: 60px;
            height: 60px;
            margin-bottom: 36px;
        }

        .step-icon img {
            width: 30px;
        }

        .wrapper-title {
            font-size: 22px;
        }

        .icon-wrapper {
            width: 40px;
            height: 40px;
        }

        .icon-wrapper img {
            width: 26px;
        }

        .step-description {
            font-size: 14px;
        }

        .step-title {
            font-size: 16px;
        }

        .earnings-value,
        .overview-value {
            font-size: 24px;
        }

        .referrals-table-row>div {
            padding: 0 14px;
            font-size: 14px;
        }

        .subtitle {
            font-size: 22px;
        }
    }

    @media(max-width: 991px) {
        .step-card {
            height: initial;
            margin-bottom: 24px;
        }

        .steps {
            margin-bottom: 40px;
        }

        .earnings-card.col-12 {
            margin-bottom: 40px;
        }

        .overview-card .active-btn {
            margin: 40px auto 0;
        }

        .referrals-list-wrapper {
            height: initial;
            margin-top: 40px;
        }

        .referrals-table-row {
            padding-bottom: 10px;
            margin-bottom: 10px;
        }

        :global(.all-referrals-btn) {
            margin: 25px auto 0;
        }
    }

    @media(max-width: 768px) {
        .images-preview {
            margin: 25px -5px 30px;
        }

        .images-preview > div {
            margin: 0 5px;
        }

        .referrals-table-header > div {
            padding: 10px 20px;
            font-size: 16px;
        }

        .referrals-table-row > div {
            padding: 10px 20px;
            font-size: 15px;
        }

        .percent:first-child,
        .percent {
            font-size: 12px;
            max-width: 120px;
        }

        .percent-count {
            font-size: 24px;
        }

        .links-card,
        .transaction-wrapper,
        .dark-wrapper,
        .earnings,
        .overview-card {
            padding: 20px 16px;
            border-radius: 16px;
        }

        .subtitle {
            font-size: 18px;
            margin-bottom: 20px;
        }

        .percents {
            border-radius: 8px;
            margin-bottom: 20px;
            padding: 16px;
        }

        .referral-image {
            max-width: 100%;
        }

        .links-card .active-btn {
            margin-top: 0;
        }

        .how-works-modal-btn {
            margin: 12px auto 0;
        }

        .transaction-wrapper {
            margin-top: 24px;
        }

        .dark-wrapper {
            margin: 40px -15px -15px;
            border-radius: 32px 32px 0 0;
        }

        .transactions {
            margin-top: 24px;
        }

        .transaction {
            padding-bottom: 8px;
            margin-bottom: 8px;
            font-size: 13px;
            border-bottom: 1px solid #343168;
        }

        .transaction .green {
            position: absolute;
            width: 60%;
        }

        .transaction>div:nth-child(2) {
            width: 60%;
            margin-top: 20px;
            padding: 0;
        }

        .transaction>div:nth-child(3) {
            width: 40%;
            align-items: center;
            display: flex;
            justify-content: flex-end;
        }

        .step-icon {
            width: 56px;
            height: 56px;
            margin-bottom: 32px;
        }

        .icon-wrapper img {
            width: 24px;
        }

        .icon-wrapper {
            margin-right: 16px;
        }

        .step-card {
            padding: 24px 16px;
            margin-bottom: 16px;
            border-radius: 16px;
        }

        .steps {
            margin-bottom: 30px;
        }

        .earnings-title {
            font-size: 15px;
            margin-bottom: 16px;
        }

        .earnings-growth {
            font-size: 12px;
            margin-top: 6px;
        }

        .earnings-card.col-12 {
            margin-bottom: 28px;
        }

        .earnings-description {
            font-size: 12px;
            margin: 8px 0 48px;
        }

        .overview-title {
            font-size: 15px;
            margin-bottom: 16px;
        }

        .wrapper-title {
            margin-bottom: 24px;
        }

        .referrals-list-wrapper {
            margin-top: 16px;
            padding: 20px 16px;
            border-radius: 16px;
        }

        .referrals-table-header > div {
            padding: 8px 16px;
            font-size: 14px;
        }

        .referrals-table-row > div {
            padding: 0 16px;
            font-size: 13px;
        }

        .referrals-table-row {
            padding-bottom: 12px;
            margin-bottom: 12px;
            border-bottom: 1px solid #343168;
        }

        .icon {
            width: 40px;
            height: 40px;
            margin: 0 10px;
        }

        .icon img {
            width: 24px;
        }

        .referrals-table-header {
            margin-bottom: 24px;
        }

        .earnings-value,
        .overview-value {
            font-size: 20px;
        }
    }
</style>
